export const RoomsInfo = [
    {
        
        type: 'deluxe',
        label: 'Deluxe',
        size: '177',
        noOfAdults: 2,
        noOfKids: 0,
        noOfKingBeds: 1,
        imagesURL: [    
            'gallery/deluxe/deluxe_2.jpg',
            'gallery/deluxe/deluxe_11.jpg',
            'gallery/deluxe/deluxe_6.jpg'
        ],
        carouselImages: [
            {
                original: 'gallery/deluxe/deluxe_1.jpg',
            },
            {
                original: 'gallery/deluxe/deluxe_2.jpg',
            },
            {
                original: 'gallery/deluxe/deluxe_3.jpg',
            },
            {
                original: 'gallery/deluxe/deluxe_4.jpg',
            },
            {
                original: 'gallery/deluxe/deluxe_5.jpg',
            },
            {
                original: 'gallery/deluxe/deluxe_6.jpg',
            },
            {
                original: 'gallery/deluxe/deluxe_7.jpg',
            },
            {
                original: 'gallery/deluxe/deluxe_8.jpg',
            },
            {
                original: 'gallery/deluxe/deluxe_9.jpg',
            },
            {
                original: 'gallery/deluxe/deluxe_10.jpg',
            },
            {
                original: 'gallery/deluxe/deluxe_11.jpg',
            },
            {
                original: 'gallery/deluxe/deluxe_12.jpg',
            },
            {
                original: 'gallery/deluxe/deluxe_13.jpg',
            },
            {
                original: 'gallery/deluxe/deluxe_14.jpg',
            },
            {
                original: 'gallery/deluxe/deluxe_15.jpg',
            },
            {
                original: 'gallery/deluxe/deluxe_16.jpg',
            }
        ],
        show: false,
        description: `
            Our Deluxe Room is where comfort meets convenience. Relax in the spacious room featuring a plush king-sized bed, perfect for a restful night's sleep. 
            For your added comfort, the room is equipped with a tea and coffee maker, allowing you to enjoy a warm beverage at your leisure. 
            Located just steps away from the entrance of the iconic Balaji Temple, this room offers the perfect blend of tranquility and accessibility.
        `
    },
    {
        type: 'superior',
        label: 'Superior',
        size: '216',
        noOfAdults: 3,
        noOfKids: 1,
        noOfKingBeds: 1,
        imagesURL: [
            'gallery/superior/superior_1.jpg',
            'gallery/superior/superior_11.jpg',
            'gallery/superior/superior_12.jpg'
        ],
        carouselImages: [
            {
                original: 'gallery/superior/superior_1.jpg',
            },
            {
                original: 'gallery/superior/superior_2.jpg',
            },
            {
                original: 'gallery/superior/superior_3.jpg',
            },
            {
                original: 'gallery/superior/superior_4.jpg',
            },
            {
                original: 'gallery/superior/superior_5.jpg',
            },
            {
                original: 'gallery/superior/superior_6.jpg',
            },
            {
                original: 'gallery/superior/superior_7.jpg',
            },
            {
                original: 'gallery/superior/superior_8.jpg',
            },
            {
                original: 'gallery/superior/superior_9.jpg',
            },
            {
                original: 'gallery/superior/superior_10.jpg',
            },
            {
                original: 'gallery/superior/superior_11.jpg',
            },
            {
                original: 'gallery/superior/superior_12.jpg',
            },
            {
                original: 'gallery/superior/superior_13.jpg',
            },
            {
                original: 'gallery/superior/superior_14.jpg',
            },
            {
                original: 'gallery/superior/superior_15.jpg',
            },
            {
                original: 'gallery/superior/superior_16.jpg',
            }
        ],
        show: false,
        description: `
            Our Superior Room is where comfort meets convenience. Relax in the spacious room featuring a plush king-sized bed, perfect for a restful night's sleep. 
            For your added comfort, the room is equipped with a tea and coffee maker, allowing you to enjoy a warm beverage at your leisure. 
            Located just steps away from the entrance of the iconic Balaji Temple, this room offers the perfect blend of tranquility and accessibility.
        `
    },
    {
        type: 'intcon',
        label: 'InterConnected Deluxe',
        size: '354',
        noOfAdults: 4,
        noOfKids: 2,
        noOfKingBeds: 2,
        imagesURL: [
            'gallery/intcon/intcon_1.jpg',
            'gallery/intcon/intcon_2.jpg',
            'gallery/intcon/intcon_3.jpg',
        ],
        carouselImages: [
            {
                original: 'gallery/intcon/intcon_1.jpg',
            },
            {
                original: 'gallery/intcon/intcon_2.jpg',
            },
            {
                original: 'gallery/intcon/intcon_3.jpg',
            },
            {
                original: 'gallery/intcon/intcon_4.jpg',
            },
            {
                original: 'gallery/intcon/intcon_5.jpg',
            },
            {
                original: 'gallery/intcon/intcon_6.jpg',
            },
            {
                original: 'gallery/intcon/intcon_7.jpg',
            },
            {
                original: 'gallery/intcon/intcon_8.jpg',
            },
            {
                original: 'gallery/intcon/intcon_9.jpg',
            },
            {
                original: 'gallery/intcon/intcon_10.jpg',
            },
            {
                original: 'gallery/intcon/intcon_11.jpg',
            },
            {
                original: 'gallery/intcon/intcon_12.jpg',
            }
        ],
        show: false,
        description: `
            Our Interconnect Deluxe Room is where comfort meets convenience. Relax in the spacious room featuring a plush king-sized bed, perfect for a restful night's sleep. 
            For your added comfort, the room is equipped with a tea and coffee maker, allowing you to enjoy a warm beverage at your leisure. 
            Located just steps away from the entrance of the iconic Balaji Temple, this room offers the perfect blend of tranquility and accessibility.
        `
    }
]

export const AmentiesInfo = [
    {
        id: 'breakfast',
        imageURL: 'amenties/breakfast.png',
        altText: 'breakfast',
        label: 'Breakfast'
    },
    {
        id: 'coffee',
        imageURL: 'amenties/coffee.png',
        altText: 'coffee',
        label: 'Coffee and tea amenities'
    },
    {
        id: 'wifi',
        imageURL: 'amenties/wifi.png',
        altText: 'wifi',
        label: 'WiFi'
    },
    {
        id: 'flattv',
        imageURL: 'amenties/flattv.png',
        altText: 'flattv',
        label: 'Flat Screen TV'
    },
    {
        id: 'airconditioning',
        imageURL: 'amenties/air_conditioning.png',
        altText: 'airconditioning',
        label: 'Air conditioning'
    },
    {
        id: 'newspaper',
        imageURL: 'amenties/newspaper.png',
        altText: 'newspaper',
        label: 'Free Weekday Newspaper'
    },
    {
        id: 'bottledwater',
        imageURL: 'amenties/bottledwater.png',
        altText: 'bottledwater',
        label: 'Free bottled water'
    }
];